import React, { FC, useEffect, useState } from "react"
import Button from "@components/Button"
import { scrollLock } from "@utils/scrollLock"
import getPageLink from "@utils/getPageLink"
import {
    ButtonWrapper,
    HamburgerMenu,
    InnerWrapper,
    LinkWrapper,
    LogoWrapper,
    MobileLinkWrapper,
    MobileMenu,
    NavBarWrapper,
    StyledLink,
    StyledMobileLink,
    MobileButtonWrapper,
    NavBarContainer,
    Submenu,
    MobileSubmenu, Hamburger
} from "./styles"
import type { NavBarProps } from "./types"

const NavBar: FC<NavBarProps> = ({
    logo,
    links,
    button
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    useEffect(() => {
        if (isMenuOpen) {
            scrollLock.enable()
        } else {
            scrollLock.disable()
        }

        return () => {
            scrollLock.disable()
        }
    }, [isMenuOpen])

    return <NavBarContainer>
        <NavBarWrapper>
            <InnerWrapper>
                <LogoWrapper href="/">
                    {logo}
                </LogoWrapper>
                <LinkWrapper>
                    {links.map((item) => <li key={item.title}>
                        <StyledLink
                            to={getPageLink(item?.page) || item.direct_url}
                        >
                            {item.title}
                        </StyledLink>
                        {item?.submenu_links && item.submenu_links.length > 0 && <Submenu>
                            {item.submenu_links?.map((submenu_item) => <li key={submenu_item.title}>
                                <StyledLink
                                    to={getPageLink(submenu_item?.page)
                                                || submenu_item.direct_url}
                                >
                                    {submenu_item.title}
                                </StyledLink>
                            </li>)}
                        </Submenu>}
                    </li>)}
                </LinkWrapper>
                <ButtonWrapper>
                    <Button
                        as="a"
                        href={button?.link}
                        color={button.color}
                        outlined={button?.outlined}
                        target="_blank"
                    >
                        {button.label}
                    </Button>
                </ButtonWrapper>
                <Hamburger
                    isMenuOpen={isMenuOpen}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span />
                </Hamburger>
            </InnerWrapper>
        </NavBarWrapper>
        <MobileMenu show={isMenuOpen}>
            <MobileLinkWrapper>
                {links.map((item) => <li key={item.title}>
                    <StyledMobileLink
                        to={getPageLink(item?.page) || item.direct_url}
                    >
                        {item.title}
                        {item?.submenu_links && item.submenu_links.length > 0 && <MobileSubmenu>
                            {item.submenu_links?.map((submenu_item) => <li key={submenu_item.title}>
                                <StyledMobileLink
                                    to={getPageLink(submenu_item?.page)
                                            || submenu_item.direct_url}
                                >
                                    {submenu_item.title}
                                </StyledMobileLink>
                            </li>)}
                        </MobileSubmenu>}
                    </StyledMobileLink>
                </li>)}
                <MobileButtonWrapper>
                    <Button
                        as="a"
                        href={button?.link}
                        color={button.color}
                        outlined={button?.outlined}
                        target="_blank"
                    >
                        {button.label}
                    </Button>
                </MobileButtonWrapper>
            </MobileLinkWrapper>
        </MobileMenu>
    </NavBarContainer>
}

export default NavBar
